export const LOWERCASE_ASCII_RANGES = [{ min: 97, max: 122 }];
export const UPPERCASE_ASCII_RANGES = [{ min: 65, max: 90 }];
export const NUMBER_ASCII_RANGES = [{ min: 48, max: 57 }];
export const SPECIALCHAR_ASCII_RANGES = [
  { min: 33, max: 47 },
  { min: 58, max: 64 },
  { min: 91, max: 96 },
  { min: 123, max: 126 }
];
